import React, { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { UPDATE_RACCORDEMENT } from "../../Utils/constant";
import { updateOne } from "../../services/service";
import { SubmitButton } from "../Widget/SubmitButton";

export const ValidationRaccordement = ({ setAdhesionChoix, setStatusOk }) => {
    const [status, setStatus] = useState("encour")
    const [isSubmit, setIsSubmit] = useState(false)
    const { id } = useParams()
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const submit = (data) => {
        setIsSubmit(true)
        const requestData = { ...data, id: id }

        updateOne(UPDATE_RACCORDEMENT, '', requestData).then((res) => {
            if (res.status === 200) {
                toast.success('Raccordement éffectuée')
            }
        }).catch((err) => {
            setIsSubmit(false)
            toast.error(err?.response?.data?.donnee)
        })
    }

    return (
        <form onSubmit={handleSubmit(submit)} className='lg:w-96'>
            <div className='my-4 space-y-4'>
                <div className='my-2'>
                    <label className="form-control  w-full">
                        <div className="label -mb-1">
                            <span className="label-text font-medium text-gray-400">
                                Date et heure de debut
                            </span>
                        </div>

                        <input
                            {...register("dateHDebut", { required: true })}
                            type="datetime-local"
                            placeholder=""
                            className="input input-bordered text-gray-500 w-full h-10 text-sm font-semibold"
                        />
                    </label>

                    <label className="form-control  w-full">
                        <div className="label -mb-1">
                            <span className="label-text font-medium text-gray-400">
                                Date et heure de fin
                            </span>
                        </div>

                        <input
                            {...register("dateHFin", { required: true })}
                            type="datetime-local"
                            placeholder=""
                            className="input input-bordered text-gray-500 w-full h-10 text-sm font-semibold"
                        />
                    </label>
                    <label className="form-control w-full">
                        <div className="label">
                            <span className="label-text text-sm font-semibold">Status du raccordement</span>
                        </div>
                        <select {...register("status", { required: true })} className="select select-bordered w-full" onChange={(e) => { setStatus(e.target.value) }}>
                            <option disabled selected>Selectionnez un status</option>
                            <option value={"EN_ATTENTE"}>En attente</option>
                            <option value={"REALISER"}>Realisé</option>
                        </select>
                        {/* <input onChange={(e) => setEtoile(e.target.value)} type="number" className="input input-bordered w-full h-12 font-medium" min={0} max={5} required /> */}
                    </label>
                </div>
                {
                    status === 'REALISER' ? (
                        <>
                            <div className='my-2'>
                                <label className="form-control w-full">
                                    <div className="label">
                                        <span className="label-text text-sm font-semibold">Resultat du raccordement</span>
                                    </div>
                                    <select {...register("resultat", { required: true })} className="select select-bordered w-full" onChange={(e) => {
                                        setAdhesionChoix(e.target.value)
                                        setStatusOk(e.target.value)
                                    }}>
                                        <option disabled selected>Selectionnez un status</option>
                                        <option value={'OK'}>OK</option>
                                        <option value={'NON_OK'}>Non OK</option>
                                        <option value={'PARTIALY_OK'}>Partilly OK</option>
                                    </select>
                                </label>
                            </div>

                            <div className='my-2'>
                                <label htmlFor="" className='text-sm font-medium'>Commentaire</label>
                                <textarea {...register('commentaire')} placeholder="Votre commentaire" className="textarea textarea-bordered textarea-sm w-full" ></textarea>
                            </div>
                        </>
                    ) : null
                }

                <SubmitButton isSubmit={isSubmit} label={'Valider'} />
            </div>
        </form>
    )
}
